import React from 'react'
import { Box } from '@mui/material'

import { DashboardPageContextType } from './DashboardsPageViewModel'
import { EdifySearch } from '../../components/form/EdifySearch/EdifySearch'
import FilterContainer from '../../components/page/FilterContainer'

interface IDashboardsFilterProps {
  vm: DashboardPageContextType
  buttonTitle?: string
  canCreate?: boolean
}

const DashboardsFilter: React.FC<IDashboardsFilterProps> = ({ vm }) => {
  const { query } = vm.queryHelper

  const onUsersTextSearch = (searchKey: string) => {
    const newQuery = { ...query, searchKey }
    vm.getOrgDashboards(0, newQuery)
  }

  return (
    <>
      <FilterContainer data-testid={'DashboardsFilter'} sx={{ marginTop: '0px', justifyContent: 'flex-end' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
            gap: '16px',
          }}
        >
          <EdifySearch
            placeholder='Search Name'
            width={'260px'}
            debounceTime={0}
            defaultValue={vm.queryHelper.query.searchKey ?? ''}
            onChange={(e: any) => {
              onUsersTextSearch(e.target.value)
            }}
            clear={() => {
              onUsersTextSearch('')
              vm.resetFilteredDashboards()
            }}
          />
        </Box>
      </FilterContainer>
    </>
  )
}

export default DashboardsFilter
